import { fileUploaderAWS } from './s3Upload';

export const insertImage = (editor, url) => {
  const image = editor.selection.j.createInside.element('img');

  image.src = url;
  image.alt = 'Notification image';
  image.style.maxWidth = '100%';
  image.style.height = 'auto';

  editor.selection.insertNode(image);
};

export const imageUpload = (editor, setLoading, setQuillValue) => {
  try {
    const input = document.createElement('input');

    input.setAttribute('type', 'file');
    input.setAttribute('multiple', '');
    input.setAttribute('accept', 'image/png,image/jpeg');
    input.click();

    input.onchange = async function () {
      const imageFiles = Array.from(input.files || []);

      for (let i = 0; i < imageFiles.length; i += 1) {
        const file = imageFiles[i];

        if (file.size > 1000000) {
          const alert = editor.alert('Please upload an image less than 1 MB', 'Image Limit');
          alert.dialogbox_content.style.display = 'grid';
          alert.dialogbox_content.style.placeItems = 'center';
          continue;
        }

        setLoading(true);

        try {
          const fileUrl = await fileUploaderAWS(file);

          setQuillValue((prev) => ({
            ...prev,
            imageUrl: fileUrl,
          }));

          insertImage(editor, fileUrl);
        } catch (err) {
          console.error('Image upload failed:', err);
          editor.alert('Image upload failed. Please try again.', 'Upload Error');
        } finally {
          setLoading(false);
        }
      }
    };
  } catch (error) {
    console.error(error);
    setLoading(false);
  }
};